import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "item side" }
const _hoisted_4 = {
  key: 1,
  href: "./",
  class: "cont first"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "./",
    class: "logo"
  }, "LINEMP3")
], -1)
const _hoisted_6 = { class: "item side" }
const _hoisted_7 = {
  key: 0,
  class: "headline"
}
const _hoisted_8 = {
  key: 0,
  class: "apps"
}
const _hoisted_9 = { class: "function" }
const _hoisted_10 = { class: "select-input-form button select-files" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "top-message" }, "Welcome to MP3 ファイルを選択または録音", -1)
const _hoisted_12 = {
  key: 1,
  class: "apps"
}
const _hoisted_13 = { class: "function" }
const _hoisted_14 = ["onclick"]
const _hoisted_15 = { class: "upload-message" }
const _hoisted_16 = { class: "filename" }
const _hoisted_17 = { class: "tag" }
const _hoisted_18 = { class: "expirs" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" ファイルの有効期限は")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("です ")
const _hoisted_21 = {
  key: 2,
  class: "apps"
}
const _hoisted_22 = { class: "function" }
const _hoisted_23 = {
  key: 0,
  class: "execution uploading"
}
const _hoisted_24 = { class: "loader-flex" }
const _hoisted_25 = { class: "process" }
const _hoisted_26 = { class: "num" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loading-css" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "status" }, "Uploading...", -1)
const _hoisted_30 = {
  key: 1,
  class: "execution converting"
}
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-flex\"><div class=\"process\">Finalize..</div><div class=\"loading\"><div class=\"loading-css\"></div></div></div><div class=\"status\">Converting</div>", 2)
const _hoisted_33 = [
  _hoisted_31
]
const _hoisted_34 = {
  key: 3,
  class: "apps"
}
const _hoisted_35 = {
  key: 0,
  class: "function"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "line" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon" }),
  /*#__PURE__*/_createTextVNode("QRコードでLINEアプリに送る")
], -1)
const _hoisted_38 = {
  key: 1,
  class: "function"
}
const _hoisted_39 = ["href", "onclick"]
const _hoisted_40 = { class: "start-message" }
const _hoisted_41 = ["href"]
const _hoisted_42 = {
  key: 4,
  class: "expirs-time"
}
const _hoisted_43 = { class: "message" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_45 = {
  key: 5,
  class: "is-error"
}
const _hoisted_46 = { class: "message" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_48 = { class: "introduction" }
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"contents\"><h3 class=\"title\">LINEMP3の紹介</h3><p class=\"text\"> 音声ファイルを友達のLINE宛にサクっと送信できちゃう、便利な無料アプリです。 </p><a href=\"https://linemp3.page.link/apps\" class=\"appli\"><i class=\"icon\"></i>インストール</a></div>", 1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode("閉じる ")
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "setting" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "ファイル有効期限", -1)
const _hoisted_55 = { class: "contents" }
const _hoisted_56 = { class: "cp_ipradio" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "3" }, "3日", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "7" }, "７日", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { for: "30" }, "30日", -1)
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<div class=\"contents\"><div class=\"menu\"><a href=\"https://linemp3.page.link/apps\" class=\"li\" target=\"_blank\" rel=\"noopener\">アプリをインストールする</a><a href=\"https://www.firewrench.com/privacy\" class=\"li\" target=\"_blank\" rel=\"noopener\">広告とプライバシー</a><a href=\"https://www.firewrench.com/about\" class=\"li\" target=\"_blank\" rel=\"noopener\">会社案内</a></div></div>", 1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode("閉じる ")
const _hoisted_63 = [
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = { class: "setting" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h4", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon share" }),
  /*#__PURE__*/_createTextVNode("ファイルを送信")
], -1)
const _hoisted_66 = { class: "contents" }
const _hoisted_67 = { class: "menu" }
const _hoisted_68 = ["href"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode("LINEで共有")
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = ["href"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_74 = /*#__PURE__*/_createTextVNode("ツイッターで共有")
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = ["href"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Facebookで共有")
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div class=\"contents\"><div class=\"menu\"><a href=\"https://linemp3.page.link/apps\" class=\"li\" target=\"_blank\" rel=\"noopener\">アプリをインストール</a><a href=\"https://www.firewrench.com/privacy\" class=\"li\" target=\"_blank\" rel=\"noopener\">広告とプライバシー</a><a href=\"https://www.firewrench.com/about\" class=\"li\" target=\"_blank\" rel=\"noopener\">会社案内</a></div></div>", 1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", { class: "icon" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createTextVNode("閉じる ")
const _hoisted_83 = [
  _hoisted_81,
  _hoisted_82
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_storng = _resolveComponent("storng")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          (_ctx.IsDefult)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "cont first",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModalFirst && _ctx.openModalFirst(...args)))
              }, "初めて"))
            : (_openBlock(), _createElementBlock("a", _hoisted_4, "リセット"))
        ]),
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, [
          (!_ctx.IsCompletion)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                href: "./",
                class: "cont setting",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModalSetting && _ctx.openModalSetting(...args)))
              }, "設定"))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                href: "./",
                class: "cont setting",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openModalShare && _ctx.openModalShare(...args)))
              }, "共有"))
        ])
      ]),
      (_ctx.IsDefult)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_7, "音声ファイルをLINEに送る"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.IsDefult)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("input", {
                type: "file",
                name: "postedFile",
                class: "inputfile",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSelectFile && _ctx.onSelectFile(...args)))
              }, null, 32)
            ])
          ]),
          _hoisted_11
        ]))
      : _createCommentVNode("", true),
    (_ctx.IsFileSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "button upload",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onUploadSubmit && _ctx.onUploadSubmit(...args))),
              onclick: 
					'gtag(\'event\', \'UploadButton\', {\'event_category\': \'Web\',\'event_label\': \'' +
					_ctx.AudioFileName +
					'\'});'
				
            }, " Upload ", 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.AudioFileName), 1)
            ]),
            _createElementVNode("p", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_storng, { class: "day" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.SelectValidDay) + "日", 1)
                ]),
                _: 1
              }),
              _hoisted_20
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.IsUploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (_ctx.Progress != 100)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.Progress), 1),
                      _hoisted_27
                    ]),
                    _hoisted_28
                  ]),
                  _hoisted_29
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.IsCompletion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          (_ctx.IsPCBrowser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", {
                  class: "qr-code",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openModalShare && _ctx.openModalShare(...args)))
                }, [
                  _createElementVNode("img", {
                    src: 
						'https://api.qrserver.com/v1/create-qr-code/?data=http://line.naver.jp/R/msg/text/?' +
						_ctx.PlayerUrlEnc
					,
                    class: "img",
                    alt: ""
                  }, null, 8, _hoisted_36),
                  _hoisted_37
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("a", {
                  href: 
					'https://social-plugins.line.me/lineit/share?url=' +
					_ctx.PlayerUrlEnc +
					'&text=' +
					_ctx.ExpirsDateEnc +
					'from=line_scheme'
				,
                  class: "button start",
                  onclick: 
					'gtag(\'event\', \'StartLineButton\', {\'event_category\': \'Web\',\'event_label\': \'' +
					this.KeyBase36 +
					'\'});'
				
                }, "Start", 8, _hoisted_39)
              ])),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              class: "link share",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openModalShare && _ctx.openModalShare(...args)))
            }, "シェアする"),
            _createElementVNode("a", {
              href: this.KeyBase36,
              class: "link preview",
              target: "_blank",
              rel: "noopener"
            }, "プレビュー", 8, _hoisted_41)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.IsCompletion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("p", _hoisted_43, [
            _hoisted_44,
            _createTextVNode("PLAY期限: " + _toDisplayString(this.ExpirsDate), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.IsError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("p", _hoisted_46, [
            _hoisted_47,
            _createTextVNode(_toDisplayString(this.ErrorMessage), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", { 'is-open': _ctx.IsModalViewFirst }]),
      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        _createElementVNode("button", {
          class: "close",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _hoisted_52)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", { 'is-open': _ctx.IsModalViewSetting }]),
      onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_53, [
        _hoisted_54,
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("form", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "3",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.SelectValidDay) = $event)),
                value: "3"
              }, null, 512), [
                [_vModelRadio, _ctx.SelectValidDay]
              ]),
              _hoisted_57,
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "7",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.SelectValidDay) = $event)),
                value: "7"
              }, null, 512), [
                [_vModelRadio, _ctx.SelectValidDay]
              ]),
              _hoisted_58,
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "30",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.SelectValidDay) = $event)),
                value: "30"
              }, null, 512), [
                [_vModelRadio, _ctx.SelectValidDay]
              ]),
              _hoisted_59
            ])
          ])
        ]),
        _hoisted_60,
        _createElementVNode("button", {
          class: "close",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _hoisted_63)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", { 'is-open': _ctx.IsModalViewShare }]),
      onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_64, [
        _hoisted_65,
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("a", {
              href: 
							'https://social-plugins.line.me/lineit/share?url=' +
							_ctx.PlayerUrlEnc +
							'&text=' +
							_ctx.ExpirsDateEnc +
							'from=line_scheme'
						,
              class: "sns line",
              target: "_blank",
              rel: "nofollow noopener noreferrer"
            }, _hoisted_71, 8, _hoisted_68),
            _createElementVNode("a", {
              href: 
							'https://twitter.com/intent/tweet?text=' +
							_ctx.PlayerUrlEnc +
							'%0D%0A' +
							_ctx.ExpirsDateEnc
						,
              class: "sns twitter",
              target: "_blank",
              rel: "nofollow noopener noreferrer"
            }, _hoisted_75, 8, _hoisted_72),
            _createElementVNode("a", {
              href: 
							'https://www.facebook.com/sharer/sharer.php?u=' + _ctx.PlayerUrlEnc
						,
              class: "sns facebook",
              target: "_blank",
              rel: "nofollow noopener noreferrer"
            }, _hoisted_79, 8, _hoisted_76)
          ])
        ]),
        _hoisted_80,
        _createElementVNode("button", {
          class: "close",
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _hoisted_83)
      ])
    ], 2)
  ], 64))
}